import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingModalComponent } from './__COMPONENTS/booking-modal/booking-modal.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HomePageComponent } from './__PAGES/home-page/home-page.component';
import { ServicesPageComponent } from './__PAGES/services-page/services-page.component';
import { ContactPageComponent } from './__PAGES/contact-page/contact-page.component';
import { ServiceDetailsComponent } from './__COMPONENTS/service-details/service-details.component';
import { TermsAndConditionsComponent } from './__PAGES/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './__PAGES/privacy-policy/privacy-policy.component';


const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'home', component: HomePageComponent },
  { path: 'home/testimonial', component: HomePageComponent },
  { path: 'book', component: BookingModalComponent },
  { path: 'services', component: ServicesPageComponent },
  { path: 'services/packs', component: ServicesPageComponent },
  { path: 'service/details/:id', component: ServiceDetailsComponent },
  { path: 'contact', component: ContactPageComponent },
  { path: 'terms', component: TermsAndConditionsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
/*   { path: 'faq', component: FaqPageComponent },
  { path: 'faq/question', component: FaqPageComponent }, */
  /* { path: 'offer', component: OurOfferComponent }, */
];

@NgModule({
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
